var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useCollectionProgress } from '../collectionProgress';
import { insertCollectionCard, removeCollectionCard } from '../actions';
import { isEmptyObject } from '../../../utils/records';
var useSlotCards = function (collectionId, slotIndex) {
    var _a, _b, _c, _d, _e, _f, _g;
    // Needed to prevent changes in the dialog after the card is selected
    var updatingEnabled = useRef(true);
    var rawProgressResponse = useCollectionProgress(collectionId);
    var _h = useState(rawProgressResponse), progressResponse = _h[0], setProgressResponse = _h[1];
    useEffect(function () {
        if (updatingEnabled.current) {
            setProgressResponse(rawProgressResponse);
        }
    }, [rawProgressResponse]);
    var dispatch = useDispatch();
    var selectCard = useCallback(function (cardId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatingEnabled.current = false;
                    return [4 /*yield*/, dispatch(insertCollectionCard(collectionId, slotIndex, cardId))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [collectionId, dispatch, slotIndex]);
    var currentlySelectedCard = useMemo(function () {
        var _a, _b, _c, _d, _e;
        var currentSlot = (_b = (_a = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.progress) === null || _a === void 0 ? void 0 : _a.slots) === null || _b === void 0 ? void 0 : _b[slotIndex];
        if (!currentSlot || isEmptyObject(currentSlot) || !currentSlot.card) {
            return undefined;
        }
        var currentCardImage = (_e = (_d = (_c = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.cards) === null || _c === void 0 ? void 0 : _c.find(function (card) { return card._id === currentSlot.card; })) === null || _d === void 0 ? void 0 : _d.cardTemplate) === null || _e === void 0 ? void 0 : _e.image;
        if (!currentCardImage) {
            return undefined;
        }
        return { _id: currentSlot.card, image: currentCardImage };
    }, [progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.cards, (_a = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.progress) === null || _a === void 0 ? void 0 : _a.slots, slotIndex]);
    var removeCurrentCard = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatingEnabled.current = false;
                    return [4 /*yield*/, dispatch(removeCollectionCard(collectionId, slotIndex))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [collectionId, dispatch, slotIndex]);
    return useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var uncheckedSlot = (_b = (_a = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection) === null || _a === void 0 ? void 0 : _a.slots) === null || _b === void 0 ? void 0 : _b[slotIndex];
        var slot = uncheckedSlot && isEmptyObject(uncheckedSlot) ? undefined : uncheckedSlot;
        var group = (_d = (_c = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection) === null || _c === void 0 ? void 0 : _c.cardGroups) === null || _d === void 0 ? void 0 : _d.find(function (g) { return g.id === (slot === null || slot === void 0 ? void 0 : slot.group); });
        var notInsertedCards = (_f = (_e = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.cards) === null || _e === void 0 ? void 0 : _e.filter(function (card) {
            var _a, _b;
            return !((_b = (_a = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.progress) === null || _a === void 0 ? void 0 : _a.slots) === null || _b === void 0 ? void 0 : _b.some(function (insertedSlot) {
                return !isEmptyObject(insertedSlot) && (insertedSlot === null || insertedSlot === void 0 ? void 0 : insertedSlot.card) === card._id;
            }));
        })) !== null && _f !== void 0 ? _f : [];
        var isCardAvailable = function (card) {
            var _a, _b, _c;
            return !card.cardCollection &&
                (!((_a = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection) === null || _a === void 0 ? void 0 : _a.noDuplicates) ||
                    !((_c = (_b = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.progress) === null || _b === void 0 ? void 0 : _b.slots) === null || _c === void 0 ? void 0 : _c.some(function (insertedCard, i) {
                        return i !== slotIndex &&
                            !isEmptyObject(insertedCard) &&
                            insertedCard.card &&
                            insertedCard.cardTemplate === card.cardTemplate._id;
                    })));
        };
        return {
            dialogHeader: (_g = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection) === null || _g === void 0 ? void 0 : _g.headline,
            isSpecialSlot: Boolean(slot === null || slot === void 0 ? void 0 : slot.specialGroup),
            noCardsContent: (_h = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection) === null || _h === void 0 ? void 0 : _h.noCardsContent,
            cards: (_l = (_k = (_j = group === null || group === void 0 ? void 0 : group.cards) === null || _j === void 0 ? void 0 : _j.map(function (groupCard) {
                return [
                    groupCard,
                    notInsertedCards.filter(function (card) { return card.cardTemplate._id === groupCard.cardTemplate; }),
                ];
            })) === null || _k === void 0 ? void 0 : _k.filter(function (_a) {
                var matchingCards = _a[1];
                return matchingCards === null || matchingCards === void 0 ? void 0 : matchingCards.length;
            })) === null || _l === void 0 ? void 0 : _l.flatMap(function (_a) {
                var groupCard = _a[0], matchingCards = _a[1];
                if (slot === null || slot === void 0 ? void 0 : slot.specialGroup) {
                    var availableCard = matchingCards.find(isCardAvailable);
                    if (availableCard) {
                        return {
                            _id: availableCard._id,
                            image: availableCard.cardTemplate.image,
                            value: groupCard.value,
                            isAvailable: true,
                            placedInCollection: null,
                        };
                    }
                }
                return matchingCards.map(function (card) {
                    var _a;
                    var isAvailable = isCardAvailable(card);
                    return __assign({ _id: card._id, image: card.cardTemplate.image, value: groupCard.value }, (isAvailable
                        ? { isAvailable: true, placedInCollection: null }
                        : {
                            isAvailable: false,
                            placedInCollection: (_a = card.cardCollection) !== null && _a !== void 0 ? _a : null,
                        }));
                });
            }),
            selectCard: selectCard,
            currentlySelectedCard: currentlySelectedCard,
            removeCurrentCard: removeCurrentCard,
        };
    }, [
        currentlySelectedCard,
        progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.cards,
        (_b = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection) === null || _b === void 0 ? void 0 : _b.cardGroups,
        (_c = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection) === null || _c === void 0 ? void 0 : _c.headline,
        (_d = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection) === null || _d === void 0 ? void 0 : _d.noCardsContent,
        (_e = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection) === null || _e === void 0 ? void 0 : _e.noDuplicates,
        (_f = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.collection) === null || _f === void 0 ? void 0 : _f.slots,
        (_g = progressResponse === null || progressResponse === void 0 ? void 0 : progressResponse.progress) === null || _g === void 0 ? void 0 : _g.slots,
        removeCurrentCard,
        selectCard,
        slotIndex,
    ]);
};
export default useSlotCards;
